import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../utils/axiosInstance";
import axios from "axios";

// Axios instance that uses superToken (for Super Admin routes)
const superAxios = axios.create({ baseURL: axiosInstance.defaults.baseURL });
superAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("superToken") || localStorage.getItem("token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// ── Akagari variant: update a Mudugudu leader under a selected Akagari
export const GuhinduraUmuyoboziAkagari = () => {
  const [akagariList, setAkagariList] = useState([]);
  const [selectedAkagari, setSelectedAkagari] = useState("");
  const [muduguduList, setMuduguduList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ fullname: "", national_id: "", email: "", telefone: "" });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ text: "", type: "" });
  const [modalMsg, setModalMsg] = useState({ text: "", type: "" });
  const [loadingMudugudu, setLoadingMudugudu] = useState(false);

  useEffect(() => {
    superAxios.get("/get_akagari")
      .then(r => setAkagariList(r.data))
      .catch(() => setMsg({ text: "Ntibyashobotse gukuramo Akagari", type: "danger" }));
  }, []);

  useEffect(() => {
    if (!selectedAkagari) { setMuduguduList([]); return; }
    setLoadingMudugudu(true);
    superAxios.get(`/get_mudugudu/${selectedAkagari}`)
      .then(r => setMuduguduList(r.data))
      .catch(() => setMsg({ text: "Ntibyashobotse gukuramo Imidugudu", type: "danger" }))
      .finally(() => setLoadingMudugudu(false));
  }, [selectedAkagari]);

  const openEdit = (u) => {
    setSelected(u);
    setForm({ fullname: u.fullname || "", national_id: u.national_id || "", email: u.email || "", telefone: u.telefone || "" });
    setModalMsg({ text: "", type: "" });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.fullname.trim()) return setModalMsg({ text: "Amazina ni ngombwa", type: "warning" });
    if (!/^\d{16}$/.test(form.national_id.replace(/\s/g, "")))
      return setModalMsg({ text: "Indangamuntu igomba kuba imibare 16", type: "warning" });
    setSaving(true);
    try {
      await superAxios.put(`/leaders/update/mudugudu/${selected.user_id}`, {
        ...form, national_id: form.national_id.replace(/\s/g, ""),
      });
      setModalMsg({ text: "✅ Amakuru yavuguruwe neza!", type: "success" });
      setTimeout(() => {
        setSelected(null);
        superAxios.get(`/get_mudugudu/${selectedAkagari}`).then(r => setMuduguduList(r.data));
      }, 900);
    } catch (err) {
      setModalMsg({ text: err.response?.data?.error || "Habaye ikosa", type: "danger" });
    } finally { setSaving(false); }
  };

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("rw-RW") : "—";

  return (
    <div className="space-y-5">
      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #003366 0%, #004080 100%)",
        borderRadius: "8px", borderLeft: "5px solid #FFD700",
        padding: "20px 24px", boxShadow: "0 2px 8px rgba(0,51,102,0.2)",
      }}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: "rgba(255,215,0,0.15)", border: "1px solid rgba(255,215,0,0.3)" }}>
            <i className="bi bi-person-gear text-xl" style={{ color: "#FFD700" }} />
          </div>
          <div>
            <h2 className="font-bold text-white text-lg leading-tight">Guhindura Umuyobozi w&apos;Umudugudu</h2>
            <p className="text-xs mt-0.5" style={{ color: "rgba(255,255,255,0.65)" }}>Hitamo Akagari hanyuma uhindure umuyobozi w&apos;Umudugudu.</p>
          </div>
        </div>
      </div>

      {msg.text && (
        <div className="flex items-center gap-2 p-3 rounded-lg text-sm font-medium"
          style={{ background: msg.type === "danger" ? "#fee2e2" : "#dcfce7", color: msg.type === "danger" ? "#991b1b" : "#166534", border: `1px solid ${msg.type === "danger" ? "#fca5a5" : "#86efac"}` }}>
          <i className={`bi bi-${msg.type === "danger" ? "exclamation-triangle-fill" : "check-circle-fill"}`} />{msg.text}
        </div>
      )}

      {/* Akagari dropdown */}
      <div style={{ background: "#fff", border: "1px solid #d1d9e6", borderRadius: "8px", padding: "20px" }}>
        <label className="block text-xs font-bold uppercase tracking-wide mb-2" style={{ color: "#64748b" }}>
          <i className="bi bi-building mr-1" style={{ color: "#003366" }} />Hitamo Akagari
        </label>
        <select
          className="w-full px-3 py-2.5 text-sm rounded-lg outline-none"
          style={{ border: "1.5px solid #d1d9e6", background: "#f8fafc", color: "#1e3a5f" }}
          value={selectedAkagari}
          onChange={e => { setSelectedAkagari(e.target.value); setSelected(null); }}
        >
          <option value="">-- Hitamo Akagari --</option>
          {akagariList.map(a => (
            <option key={a.user_id} value={a.user_id}>{a.fullname} — {a.national_id}</option>
          ))}
        </select>
      </div>

      {/* Edit Modal */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(4px)" }}>
          <div className="w-full max-w-lg max-h-[92vh] overflow-y-auto"
            style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 20px 60px rgba(0,51,102,0.25)", border: "1px solid #d1d9e6" }}>
            <div className="flex items-center justify-between px-6 py-4"
              style={{ borderBottom: "2px solid #003366", background: "#003366", borderRadius: "12px 12px 0 0" }}>
              <div className="flex items-center gap-2">
                <i className="bi bi-person-gear text-lg" style={{ color: "#FFD700" }} />
                <h3 className="font-bold text-white text-sm">{selected.fullname}</h3>
              </div>
              <button onClick={() => setSelected(null)}
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "none" }}>
                <i className="bi bi-x-lg text-sm" />
              </button>
            </div>
            <div className="p-6">
              {modalMsg.text && (
                <div className="flex items-center gap-2 p-3 rounded-lg text-sm font-medium mb-4"
                  style={{ background: modalMsg.type === "success" ? "#dcfce7" : modalMsg.type === "danger" ? "#fee2e2" : "#fef3c7", color: modalMsg.type === "success" ? "#166534" : modalMsg.type === "danger" ? "#991b1b" : "#92400e", border: "1px solid #d1d9e6" }}>
                  {modalMsg.text}
                </div>
              )}
              <form onSubmit={handleSave} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wide mb-1.5" style={{ color: "#64748b" }}>Indangamuntu (16)</label>
                  <input className="w-full px-3 py-2.5 text-sm rounded-lg outline-none font-mono"
                    style={{ border: "1.5px solid #d1d9e6", background: "#f8fafc", color: "#1e3a5f" }}
                    name="national_id" value={form.national_id} onChange={e => setForm(p => ({ ...p, national_id: e.target.value }))}
                    maxLength={16} required />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wide mb-1.5" style={{ color: "#64748b" }}>Amazina Yose</label>
                  <input className="w-full px-3 py-2.5 text-sm rounded-lg outline-none"
                    style={{ border: "1.5px solid #d1d9e6", background: "#f8fafc", color: "#1e3a5f" }}
                    name="fullname" value={form.fullname} onChange={e => setForm(p => ({ ...p, fullname: e.target.value }))}
                    required />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-bold uppercase tracking-wide mb-1.5" style={{ color: "#64748b" }}>Imeyili</label>
                    <input className="w-full px-3 py-2.5 text-sm rounded-lg outline-none"
                      style={{ border: "1.5px solid #d1d9e6", background: "#f8fafc", color: "#1e3a5f" }}
                      type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
                  </div>
                  <div>
                    <label className="block text-xs font-bold uppercase tracking-wide mb-1.5" style={{ color: "#64748b" }}>Telefone</label>
                    <input className="w-full px-3 py-2.5 text-sm rounded-lg outline-none"
                      style={{ border: "1.5px solid #d1d9e6", background: "#f8fafc", color: "#1e3a5f" }}
                      value={form.telefone} onChange={e => setForm(p => ({ ...p, telefone: e.target.value }))} />
                  </div>
                </div>
                <div className="flex gap-3 pt-2">
                  <button type="submit" disabled={saving}
                    className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-bold disabled:opacity-50"
                    style={{ background: "#003366", color: "#FFD700", border: "none" }}>
                    {saving ? <>Tegereza...</> : <><i className="bi bi-check-lg" />Guhindura Umuyobozi</>}
                  </button>
                  <button type="button" onClick={() => setSelected(null)}
                    className="flex-1 py-2.5 rounded-lg text-sm font-semibold"
                    style={{ background: "#f1f5f9", color: "#475569", border: "1px solid #d1d9e6" }}>Reka</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Mudugudu table */}
      {selectedAkagari && (
        <div style={{ background: "#fff", border: "1px solid #d1d9e6", borderRadius: "8px", overflow: "hidden" }}>
          <div className="px-5 py-3 flex items-center gap-2"
            style={{ borderBottom: "2px solid #003366", background: "#003366" }}>
            <i className="bi bi-people-fill" style={{ color: "#FFD700" }} />
            <h3 className="text-sm font-bold text-white">Imidugudu</h3>
          </div>
          {loadingMudugudu ? (
            <div className="flex items-center justify-center py-12 gap-2 text-sm" style={{ color: "#64748b" }}>
              <span className="animate-spin inline-block w-5 h-5 border-2 border-t-transparent rounded-full"
                style={{ borderColor: "#003366", borderTopColor: "transparent" }} />Gutegereza...
            </div>
          ) : muduguduList.length === 0 ? (
            <div className="text-center py-12 text-sm" style={{ color: "#64748b" }}>Nta midugudu ibonetse muri iki Kagari</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm min-w-[600px]">
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                    {["#", "Amazina", "Indangamuntu", "Imeyili", "Telefone", "Yanditswe", "Ibikorwa"].map(h => (
                      <th key={h} className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wide" style={{ color: "#64748b" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {muduguduList.map((u, i) => (
                    <tr key={u.user_id} style={{ borderBottom: "1px solid #f1f5f9" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f0f4ff"}
                      onMouseLeave={e => e.currentTarget.style.background = ""}>
                      <td className="px-4 py-3 text-xs font-mono" style={{ color: "#64748b" }}>{i + 1}</td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                            style={{ background: "#dbeafe", color: "#1e40af" }}>
                            {u.fullname?.charAt(0)?.toUpperCase()}
                          </div>
                          <span className="font-semibold" style={{ color: "#1e3a5f" }}>{u.fullname}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3 font-mono text-xs" style={{ color: "#1e3a5f" }}>{u.national_id}</td>
                      <td className="px-4 py-3 text-xs" style={{ color: "#64748b" }}>{u.email || "—"}</td>
                      <td className="px-4 py-3 text-xs" style={{ color: "#64748b" }}>{u.telefone || "—"}</td>
                      <td className="px-4 py-3 text-xs" style={{ color: "#64748b" }}>{fmtDate(u.created_at)}</td>
                      <td className="px-4 py-3">
                        <button onClick={() => openEdit(u)}
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold"
                          style={{ background: "#003366", color: "#FFD700", border: "none" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#004080"}
                          onMouseLeave={e => e.currentTarget.style.background = "#003366"}>
                          <i className="bi bi-pencil-fill" />Guhindura Umuyobozi
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const ROLE_COLORS = {
  Isibo:         { bg: "#dbeafe", color: "#1e40af", border: "#93c5fd" },
  Umunyamabanga: { bg: "#ede9fe", color: "#6d28d9", border: "#c4b5fd" },
};

const Alert = ({ msg }) => {
  if (!msg.text) return null;
  const styles = {
    success: { bg: "#dcfce7", color: "#166534", border: "#86efac", icon: "check-circle-fill" },
    danger:  { bg: "#fee2e2", color: "#991b1b", border: "#fca5a5", icon: "exclamation-triangle-fill" },
    warning: { bg: "#fef3c7", color: "#92400e", border: "#fcd34d", icon: "exclamation-triangle-fill" },
  };
  const s = styles[msg.type] || styles.warning;
  return (
    <div className="flex items-center gap-2 p-3 rounded-lg text-sm font-medium mb-3"
      style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}` }}>
      <i className={`bi bi-${s.icon}`}></i>
      {msg.text}
    </div>
  );
};

const Field = ({ label, icon, children }) => (
  <div>
    <label className="block text-xs font-bold uppercase tracking-wide mb-1.5"
      style={{ color: "#64748b" }}>
      <i className={`bi bi-${icon} mr-1`} style={{ color: "#003366" }}></i>{label}
    </label>
    {children}
  </div>
);

const inputCls = "w-full px-3 py-2.5 text-sm rounded-lg transition-all outline-none";
const inputStyle = {
  border: "1.5px solid #d1d9e6",
  background: "#f8fafc",
  color: "#1e3a5f",
};
const inputFocusStyle = {
  border: "1.5px solid #003366",
  background: "#fff",
  boxShadow: "0 0 0 3px rgba(0,51,102,0.08)",
};

const StyledInput = ({ mono, ...props }) => {
  const [focused, setFocused] = useState(false);
  return (
    <input
      {...props}
      className={inputCls + (mono ? " font-mono tracking-wider" : "")}
      style={{ ...inputStyle, ...(focused ? inputFocusStyle : {}) }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
};

const StyledSelect = ({ ...props }) => {
  const [focused, setFocused] = useState(false);
  return (
    <select
      {...props}
      className={inputCls}
      style={{ ...inputStyle, ...(focused ? inputFocusStyle : {}) }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
};

const GuhinduraUmuyobozi = () => {
  const [users, setUsers]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);
  const [form, setForm]         = useState({ fullname: "", national_id: "", email: "", telefone: "", role: "" });
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState({ text: "", type: "" });
  const [modalMsg, setModalMsg] = useState({ text: "", type: "" });
  const [search, setSearch]     = useState("");

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/get_abandi_by_mudugudu");
      setUsers(res.data);
    } catch {
      setMsg({ text: "Ntibyashobotse gukuramo abayobozi", type: "danger" });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchUsers(); }, [fetchUsers]);

  const openEdit = (user) => {
    setSelected(user);
    setForm({
      fullname:    user.fullname    || "",
      national_id: user.national_id || "",
      email:       user.email       || "",
      telefone:    user.telefone    || "",
      role:        user.role        || "",
    });
    setModalMsg({ text: "", type: "" });
  };

  const handleChange = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.fullname.trim())    return setModalMsg({ text: "Amazina ni ngombwa", type: "warning" });
    if (!form.national_id.trim()) return setModalMsg({ text: "Indangamuntu ni ngombwa", type: "warning" });
    if (!/^\d{16}$/.test(form.national_id.replace(/\s/g, "")))
      return setModalMsg({ text: "Indangamuntu igomba kuba imibare 16", type: "warning" });
    setSaving(true);
    try {
      await axiosInstance.put(`/update_abandi/${selected.user_id}`, {
        ...form,
        national_id: form.national_id.replace(/\s/g, ""),
      });
      setModalMsg({ text: "Amakuru yavuguruwe neza!", type: "success" });
      setTimeout(() => { setSelected(null); fetchUsers(); }, 900);
    } catch (err) {
      setModalMsg({ text: err.response?.data?.error || "Habaye ikosa", type: "danger" });
    } finally {
      setSaving(false);
    }
  };

  const filtered = users.filter(u =>
    [u.fullname, u.national_id, u.email, u.telefone, u.role]
      .some(v => v?.toLowerCase().includes(search.toLowerCase()))
  );

  const fmtDate = (d) => d ? new Date(d).toLocaleString("rw-RW", { dateStyle: "short", timeStyle: "short" }) : "—";

  return (
    <div className="space-y-5">

      {/* ── Header ── */}
      <div style={{
        background: "linear-gradient(135deg, #003366 0%, #004080 100%)",
        borderRadius: "8px",
        borderLeft: "5px solid #FFD700",
        padding: "20px 24px",
        boxShadow: "0 2px 8px rgba(0,51,102,0.2)",
      }}>
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ background: "rgba(255,215,0,0.15)", border: "1px solid rgba(255,215,0,0.3)" }}>
              <i className="bi bi-person-gear text-xl" style={{ color: "#FFD700" }} />
            </div>
            <div className="min-w-0">
              <h2 className="font-bold text-white text-lg leading-tight truncate">Guhindura Umuyobozi</h2>
              <p className="text-xs mt-0.5 truncate" style={{ color: "rgba(255,255,255,0.65)" }}>
                Vugurura amakuru y'abayobozi bari munsi yawe.
              </p>
            </div>
          </div>
          <span className="ml-auto text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap"
            style={{ background: "rgba(255,215,0,0.15)", color: "#FFD700", border: "1px solid rgba(255,215,0,0.3)" }}>
            <i className="bi bi-people-fill mr-1" />{filtered.length} Abayobozi
          </span>
        </div>
      </div>

      <Alert msg={msg} />

      {/* ── Edit Modal ── */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(4px)" }}>
          <div className="w-full max-w-lg max-h-[92vh] overflow-y-auto"
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 20px 60px rgba(0,51,102,0.25)",
              border: "1px solid #d1d9e6",
            }}>

            {/* Modal header */}
            <div className="flex items-center justify-between gap-2 px-4 sm:px-6 py-4"
              style={{ borderBottom: "2px solid #003366", background: "#003366", borderRadius: "12px 12px 0 0" }}>
              <div className="flex items-center gap-2 min-w-0">
                <i className="bi bi-person-gear text-lg flex-shrink-0" style={{ color: "#FFD700" }} />
                <div className="min-w-0">
                  <p className="text-xs font-semibold" style={{ color: "rgba(255,255,255,0.6)" }}>Vugurura amakuru</p>
                  <h3 className="font-bold text-white text-sm leading-tight truncate">{selected.fullname}</h3>
                </div>
              </div>
              <button onClick={() => setSelected(null)}
                className="w-8 h-8 rounded-lg flex items-center justify-center transition-all flex-shrink-0"
                style={{ background: "rgba(255,255,255,0.1)", color: "#fff" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}>
                <i className="bi bi-x-lg text-sm" />
              </button>
            </div>

            <div className="p-4 sm:p-6">
              <Alert msg={modalMsg} />

              {/* Info strip */}
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg mb-5 text-xs"
                style={{ background: "#f0f4ff", border: "1px solid #c7d7f5", color: "#1e3a5f" }}>
                <i className="bi bi-calendar-check" style={{ color: "#003366" }} />
                <span><strong>Yanditswe:</strong> {fmtDate(selected.created_at)}</span>
              </div>

              <form onSubmit={handleSave} className="space-y-4">
                <Field label="Indangamuntu (16)" icon="fingerprint">
                  <StyledInput mono name="national_id" value={form.national_id} onChange={handleChange}
                    maxLength={16} inputMode="numeric" placeholder="1190000000000000" required />
                </Field>

                <Field label="Amazina Yose" icon="person">
                  <StyledInput name="fullname" value={form.fullname} onChange={handleChange}
                    placeholder="Amazina yose" required />
                </Field>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <Field label="Imeyili" icon="envelope">
                    <StyledInput name="email" type="email" value={form.email} onChange={handleChange}
                      placeholder="imeyili@example.com" />
                  </Field>
                  <Field label="Telefone" icon="telephone">
                    <StyledInput name="telefone" value={form.telefone} onChange={handleChange}
                      placeholder="07XXXXXXXX" />
                  </Field>
                </div>

                <Field label="Inshingano" icon="briefcase">
                  <StyledSelect name="role" value={form.role} onChange={handleChange}>
                    <option value="">-- Hitamo --</option>
                    <option value="Isibo">Umuyobozi w'Isibo</option>
                    <option value="Umunyamabanga">Miberehomyiza</option>
                  </StyledSelect>
                </Field>

                <div className="flex gap-3 pt-2">
                  <button type="submit" disabled={saving}
                    className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-bold transition-all disabled:opacity-50"
                    style={{ background: "#003366", color: "#FFD700", border: "none" }}
                    onMouseEnter={e => { if (!saving) e.currentTarget.style.background = "#004080"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "#003366"; }}>
                    {saving
                      ? <><span className="animate-spin inline-block w-4 h-4 border-2 border-yellow-400 border-t-transparent rounded-full" />Tegereza...</>
                      : <><i className="bi bi-check-lg" />Emeza</>}
                  </button>
                  <button type="button" onClick={() => setSelected(null)}
                    className="flex-1 py-2.5 rounded-lg text-sm font-semibold transition-all"
                    style={{ background: "#f1f5f9", color: "#475569", border: "1px solid #d1d9e6" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#e2e8f0"}
                    onMouseLeave={e => e.currentTarget.style.background = "#f1f5f9"}>
                    Reka
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── Table card ── */}
      <div style={{
        background: "#fff",
        border: "1px solid #d1d9e6",
        borderRadius: "8px",
        boxShadow: "0 1px 4px rgba(0,51,102,0.08)",
        overflow: "hidden",
      }}>
        {/* Card header */}
        <div className="flex items-center justify-between gap-3 flex-wrap px-5 py-3"
          style={{ borderBottom: "2px solid #003366", background: "#003366" }}>
          <div className="flex items-center gap-2">
            <i className="bi bi-people-fill" style={{ color: "#FFD700" }} />
            <h3 className="text-sm font-bold text-white">
              Abayobozi <span className="ml-1 px-2 py-0.5 rounded-full text-xs font-bold"
                style={{ background: "rgba(255,215,0,0.2)", color: "#FFD700" }}>
                {filtered.length}
              </span>
            </h3>
          </div>
          <div className="relative w-full sm:w-48">
            <i className="bi bi-search absolute left-3 top-1/2 -translate-y-1/2 text-xs"
              style={{ color: "rgba(255,255,255,0.5)" }} />
            <input value={search} onChange={e => setSearch(e.target.value)}
              className="pl-8 pr-3 py-1.5 text-xs rounded-lg outline-none w-full"
              style={{
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#fff",
              }}
              placeholder="Shakisha..."
              onFocus={e => { e.target.style.background = "rgba(255,255,255,0.18)"; e.target.style.borderColor = "rgba(255,215,0,0.5)"; }}
              onBlur={e => { e.target.style.background = "rgba(255,255,255,0.1)"; e.target.style.borderColor = "rgba(255,255,255,0.2)"; }}
            />
          </div>
        </div>

        {/* Body */}
        {loading ? (
          <div className="flex items-center justify-center py-16 gap-3 text-sm" style={{ color: "#64748b" }}>
            <span className="animate-spin inline-block w-5 h-5 border-2 border-t-transparent rounded-full"
              style={{ borderColor: "#003366", borderTopColor: "transparent" }} />
            Gutegereza...
          </div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-16" style={{ color: "#64748b" }}>
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"
              style={{ background: "#f0f4ff" }}>
              <i className="bi bi-people text-3xl" style={{ color: "#003366" }} />
            </div>
            <p className="text-sm font-semibold" style={{ color: "#1e3a5f" }}>Nta bayobozi babonetse</p>
            <p className="text-xs mt-1" style={{ color: "#64748b" }}>Shakisha izina cyangwa inshingano</p>
          </div>
        ) : (
          <>
            {/* Mobile card list (below md) */}
            <div className="md:hidden divide-y" style={{ borderColor: "#f1f5f9" }}>
              {filtered.map((u, i) => {
                const rc = ROLE_COLORS[u.role] || { bg: "#f1f5f9", color: "#475569", border: "#cbd5e1" };
                return (
                  <div key={u.user_id} className="p-4 space-y-3">
                    <div className="flex items-center gap-2.5">
                      <div className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                        style={{ background: "#dbeafe", color: "#1e40af" }}>
                        {u.fullname?.charAt(0)?.toUpperCase() || "?"}
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="font-semibold text-sm truncate" style={{ color: "#1e3a5f" }}>{u.fullname}</p>
                        <p className="text-xs font-mono tracking-wider truncate" style={{ color: "#64748b" }}>{u.national_id}</p>
                      </div>
                      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-bold flex-shrink-0"
                        style={{ background: rc.bg, color: rc.color, border: `1px solid ${rc.border}` }}>
                        <i className="bi bi-person-badge" />
                        {u.role || "—"}
                      </span>
                    </div>
                    <div className="grid grid-cols-1 gap-1 text-xs" style={{ color: "#64748b" }}>
                      <div className="flex items-center gap-1.5 truncate">
                        <i className="bi bi-envelope" style={{ color: "#94a3b8" }} />{u.email || "—"}
                      </div>
                      <div className="flex items-center gap-1.5">
                        <i className="bi bi-telephone" style={{ color: "#94a3b8" }} />{u.telefone || "—"}
                      </div>
                      <div className="flex items-center gap-1.5">
                        <i className="bi bi-calendar-check" style={{ color: "#94a3b8" }} />{fmtDate(u.created_at)}
                      </div>
                    </div>
                    <button onClick={() => openEdit(u)}
                      className="w-full flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-bold active:scale-95"
                      style={{ background: "#003366", color: "#FFD700", border: "none" }}>
                      <i className="bi bi-pencil-fill" />
                      Hindura
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Desktop table (md and up) */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-sm min-w-[720px]">
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                    {["#", "Indangamuntu", "Amazina", "Imeyili", "Telefone", "Inshingano", "Yanditswe", "Ibikorwa"].map(h => (
                      <th key={h} className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wide"
                        style={{ color: "#64748b" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((u, i) => {
                    const rc = ROLE_COLORS[u.role] || { bg: "#f1f5f9", color: "#475569", border: "#cbd5e1" };
                    return (
                      <tr key={u.user_id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f0f4ff"}
                        onMouseLeave={e => e.currentTarget.style.background = ""}>
                        <td className="px-4 py-3 text-xs font-mono" style={{ color: "#64748b" }}>{i + 1}</td>
                        <td className="px-4 py-3 font-mono text-xs font-semibold tracking-wider"
                          style={{ color: "#1e3a5f" }}>{u.national_id}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                              style={{ background: "#dbeafe", color: "#1e40af" }}>
                              {u.fullname?.charAt(0)?.toUpperCase() || "?"}
                            </div>
                            <span className="font-semibold text-sm" style={{ color: "#1e3a5f" }}>{u.fullname}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs" style={{ color: "#64748b" }}>{u.email || "—"}</td>
                        <td className="px-4 py-3 text-xs" style={{ color: "#64748b" }}>{u.telefone || "—"}</td>
                        <td className="px-4 py-3">
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold"
                            style={{ background: rc.bg, color: rc.color, border: `1px solid ${rc.border}` }}>
                            <i className="bi bi-person-badge" />
                            {u.role || "—"}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-xs whitespace-nowrap" style={{ color: "#64748b" }}>
                          {fmtDate(u.created_at)}
                        </td>
                        <td className="px-4 py-3">
                          <button onClick={() => openEdit(u)}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all active:scale-95"
                            style={{ background: "#003366", color: "#FFD700", border: "none" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#004080"}
                            onMouseLeave={e => e.currentTarget.style.background = "#003366"}>
                            <i className="bi bi-pencil-fill" />
                            Hindura
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GuhinduraUmuyobozi;
